import { inputField } from '@/ui/components/form';
import { t } from '@/ui/i18n/i18n';
import { ComputedRef, Ref } from 'vue';
import { SsoConfiguration } from '@/entities/sso-configuration';
import { Task } from '@/ui/concerns';
import { ValidationError } from '@/entities/validation';
import { oAuthConfiguration } from '@/services/api/resources/sso-configuration';

export const OAuthFormFields = (record: Ref<SsoConfiguration>, validationErrors: ComputedRef<ValidationError[]>, task: Task) => {
  const configuration = <oAuthConfiguration>(record.value.configuration);

  return [
    inputField(
      {
        name: 'configuration.authorizationUri',
        label: t('sso.authorization-uri'),
        tooltipText: t('sso.tooltips.oauth2-authorization-uri'),
        value: configuration.authorizationUri || '',
        placeholder: t('sso.authorization-uri'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.authorizationUri = value;
      },
    ),
    inputField(
      {
        name: 'configuration.tokenUri',
        label: t('sso.token-uri'),
        tooltipText: t('sso.tooltips.token-uri'),
        value: configuration.tokenUri || '',
        placeholder: t('sso.token-uri'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.tokenUri = value;
      },
    ),
    inputField(
      {
        name: 'configuration.userInfoUri',
        label: t('sso.userinfo-uri'),
        tooltipText: t('sso.tooltips.userinfo-uri'),
        value: configuration.userInfoUri || '',
        placeholder: t('sso.userinfo-uri'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.userInfoUri = value;
      },
    ),
    inputField(
      {
        name: 'configuration.clientId',
        label: t('sso.client-id'),
        tooltipText: t('sso.tooltips.client-id'),
        value: configuration.clientId || '',
        placeholder: t('sso.client-id'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.clientId = value;
      },
    ),
    inputField(
      {
        name: 'configuration.clientSecret',
        label: t('sso.client-secret'),
        tooltipText: t('sso.tooltips.client-secret'),
        value: configuration.clientSecret || '',
        placeholder: t('sso.client-secret'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.clientSecret = value;
      },
    ),
    inputField(
      {
        name: 'configuration.scope',
        label: t('sso.scope'),
        tooltipText: t('sso.tooltips.scope'),
        value: configuration.scope || '',
        placeholder: t('sso.scope'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.scope = value;
      },
    ),
  ];
};
